//@flow
//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import 'moment/locale/pt-br';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect }  from 'react-redux';
import { Button, Label } from 'reactstrap';
import * as Yup from 'yup';
import { SalasAtendimento } from '../../components/SalasAtendimento/SalasAtendimento';
import { estabelecimentoService } from '../../_services/estabelecimento.service';

type Props = {
  match: any,
  nome?: string,
  callbackOnSave?: any,
};

type State = {
  id?: number,
};

const EstabelecimentoValidateSalas = Yup.object().shape({
  listConfiguracaoSala: Yup.array()
    .min(1, 'É necessario informar pelo menos um telefone')
    .of(
      Yup.object().shape({
        nome: Yup.string().required('Obrigatório'),
        inicioNumero: Yup.string().required('Obrigatório'),
        fimNumero: Yup.string().required('Obrigatório'),
      })
    ),
});

class ConsultoriosForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  addItemInArray = (propName, defaultValue, values, setValues) => {
    let newValues = _.cloneDeep(values);
    newValues[propName].push(
      defaultValue ? defaultValue : { idList: new Date().getTime() }
    );
    setValues(newValues);
  };

  removeItemInArray = (propName, indexItem, values, setValues) => {
    let newValues = _.cloneDeep(values);
    if (newValues[propName].length > 1) {
      newValues[propName].splice(indexItem, 1);
      setValues(newValues);
    }
  };

  goToViewEntity = (values) => {
    this.props.history.push({
      pathname: '/estabelecimento/view/' + values.id,
      state: { entity: values },
    });
  };

  resetForm = (initialValues) => {
    this.formRef.resetForm(initialValues);
  };

  saveForm = () => {
    let _this = this;

    let values = _this.formRef.state.values;
    let promise = new Promise(function (resolve) {
      _this.formRef.validateForm(values).then((error) => {
        if (_.isEmpty(error)) {
          _this.props.loading(true);
          estabelecimentoService
            .saveConsultorio(values, values.listConfiguracaoSala)
            .then(
              (r) => {
                _this.props.success({
                  message: `Consultórios, salvo com sucesso!`,
                });
                _this.props.loading(false);
                //_this.goToViewEntity(values);
                resolve(true);
              },
              (error) => {
                _this.props.loading(false);
                _this.props.error({
                  message: 'Não foi possível salvar Consultórios.',
                });
                console.log(error);
              }
            );
        } else {
          resolve(false);
        }
      });
    });
    return promise;
  };

  getCountConsultorios = (listConfiguracaoSala) => {
    let count = 0;
    for (let i = 0; i < listConfiguracaoSala.length; i++) {
      if (listConfiguracaoSala[i].id) {
        count =
          count +
          (listConfiguracaoSala[i].fimNumero -
            listConfiguracaoSala[i].inicioNumero) +
          1;
      }
    }
    if (count > 0) {
      return `${count} Consultórios  cadastrados`;
    }
    return `Nenhum consultório cadastrado`;
  };

  render() {
    let _this = this;
    const { viewMode, entity } = this.props;
    return (
      <React.Fragment>
        <Formik
          validationSchema={EstabelecimentoValidateSalas}
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={entity}
          ref={(form) => {
            this.formRef = form;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            validationSchema,
            validateForm,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-inside">
                {viewMode && (
                  <div className="row section-form">
                    <p className="instruction">
                      O cadastro de consultório é utilizado para o profissional
                      de saúde identificar o seu local de trabalho e o mesmo,
                      ser apresentado na TV ao chamar o paciente.
                    </p>
                  </div>
                )}
                {!viewMode &&
                  values.listConfiguracaoSala &&
                  values.listConfiguracaoSala.map((sala, index) => {
                    return (
                      <div className="row section-form" key={index}>
                        <SalasAtendimento
                          key={sala.id ? sala.id : sala.idList}
                          entity={values}
                          index={index}
                          size={values.listConfiguracaoSala.length}
                          viewMode={viewMode}
                          propName={`listConfiguracaoSala[${index}]`}
                          onChange={setFieldValue}
                          removeItem={() => {
                            this.removeItemInArray(
                              `listConfiguracaoSala`,
                              index,
                              values,
                              setValues
                            );
                          }}
                          errors={errors}
                        ></SalasAtendimento>
                      </div>
                    );
                  })}
                {viewMode && (
                  <React.Fragment>
                    <React.Fragment>
                      <Label className="pl-5px">
                        {this.getCountConsultorios(values.listConfiguracaoSala)}
                      </Label>{' '}
                    </React.Fragment>

                    {values.listConfiguracaoSala &&
                      values.listConfiguracaoSala.map((sala, index) => {
                        if (sala.id) {
                          return (
                            <div
                              className="item-view"
                              key={index + '-' + sala.id}
                            >
                              <p className={`form-view`} key={sala.id}>
                                {_.get(sala, 'nome', '--')} {' - '}{' '}
                                <b>
                                  {_.get(sala, 'inicioNumero', '--')}
                                  {' à '}
                                  {_.get(sala, 'fimNumero', '--')}
                                </b>
                              </p>
                            </div>
                          );
                        }
                      })}
                  </React.Fragment>
                )}
                <div
                  className={`form-row justify-content-md-start justify-content-center pl-10px ${
                    viewMode ? 'd-none' : ' d-flex '
                  }`}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() =>
                      this.addItemInArray(
                        'listConfiguracaoSala',
                        null,
                        values,
                        setValues
                      )
                    }
                  >
                    Adicionar outro consultório
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
  authentication: { refreshUser },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(ConsultoriosForm);
